/**
 * Query keys for CPP (Cost Per Point) rate card API hooks
 *
 * Centralized query keys enable consistent cache invalidation across all CPP rate card hooks.
 *
 * Usage:
 *   import { costPerPointQueryKeys } from '~/hooks/apis/costPerPoint/costPerPointQueryKeys';
 */
import type { CppRateCardListFilters } from '~/types/costPerPoint';

export const costPerPointQueryKeys = {
  all: ['loyalty', 'cost-per-point'] as const,
  lists: () => [...costPerPointQueryKeys.all, 'list'] as const,
  list: (filters?: CppRateCardListFilters) => [...costPerPointQueryKeys.lists(), filters] as const,
  details: () => [...costPerPointQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...costPerPointQueryKeys.details(), id] as const,
  expiring: (withinDays: number) => [...costPerPointQueryKeys.all, 'expiring', withinDays] as const,
  partners: () => [...costPerPointQueryKeys.all, 'partners'] as const,
};
